import { Component } from '@ecs/Component';

/** Repair crews welding a ship's hull. */
export class Welding implements Component {
  readonly type = 'Welding';
  public frame = 0;

  constructor(public duration: number = 60) {}
}
